import { takeLatest, call, put, all } from 'redux-saga/effects';
import { resetPasswordAct } from './actions';
import { getErrorMessage } from '../../utils/error.util';
import { addMessage } from '../ToastMessagesManager/actions';
import { resetPasswordApi } from '../../api/auth.api';

function* resetPassword({ payload }) {
  const { loadingState, data: apiPayload } = payload;
  if (loadingState === 1) {
    try {
      const data = yield call(resetPasswordApi, apiPayload);
      if (data) {
        yield all([
          put(
            addMessage({
              message: 'Your password is successfully updated.',
              variant: 'success',
            }),
          ),
          put(resetPasswordAct(2)),
        ]);
      } else {
        throw new Error('Unable to reset the password');
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      yield all([
        put(addMessage({ message: errorMessage, variant: 'error' })),
        put(resetPasswordAct(3)),
      ]);
    }
  }
}

// Individual exports for testing
export default function* resetPasswordSaga() {
  yield takeLatest(resetPasswordAct.toString(), resetPassword);
}
